import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, matchPath, NavLink } from 'react-router-dom';
import { getDimmedTextColor } from 'utils/ui';
import Box from 'components/Box';
import Button from 'components/Button';
import DotIcon from 'components/icons/lib/Dot';
import Flex from 'components/Flex';
import Hidden from 'components/Hidden';
import MatchTextWidth from 'components/MatchTextWidth';
import Status from 'components/Status';
import TooltipButton from 'components/TooltipButton';
import useBreakpoints from 'hooks/useBreakpoints';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function EditorSaveStatus(_ref) {
  var noUnsavedChangesText = _ref.noUnsavedChangesText,
    hasUnsavedChanges = _ref.hasUnsavedChanges,
    isSaving = _ref.isSaving,
    onSave = _ref.onSave,
    stateOptions = _ref.stateOptions,
    previewOptions = _ref.previewOptions,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    tooltipTitle = _ref.tooltipTitle,
    buttonText = _ref.buttonText,
    _ref$justifyContent = _ref.justifyContent,
    justifyContent = _ref$justifyContent === void 0 ? 'right' : _ref$justifyContent,
    breakpoints = _ref.breakpoints;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var location = useLocation();
  var isSaveDisabled = !hasUnsavedChanges || isDisabled;
  var _useBreakpoints = useBreakpoints(['xxs', 's']),
    xxs = _useBreakpoints.xxs,
    s = _useBreakpoints.s;
  var statusText = hasUnsavedChanges ? t('state_unsaved_changes') : noUnsavedChangesText || t('state_no_changes_since_your_last_edit');
  var previewLocation = '';
  var isPreviewActive = false;
  if (previewOptions) {
    isPreviewActive = !!matchPath(location.pathname, {
      path: previewOptions.previewPath,
      exact: true
    });
    previewLocation = _objectSpread(_objectSpread({}, location), {}, {
      pathname: isPreviewActive ? previewOptions.exitPath : previewOptions.previewPath
    });
  }
  return /*#__PURE__*/_jsxs(Flex, {
    gap: "m",
    fontSize: "s",
    justifyContent: justifyContent,
    breakpoints: breakpoints,
    children: [/*#__PURE__*/_jsx(Box, {
      shrink: true,
      textAlign: "right",
      py: "xxs",
      children: /*#__PURE__*/_jsxs(Flex, {
        shrink: true,
        gap: "xs",
        children: [/*#__PURE__*/_jsxs(Status, {
          shrink: true,
          as: "span",
          mr: stateOptions ? [undefined, 's'] : undefined,
          breakpoints: "s",
          overflow: "ellipsis",
          children: [/*#__PURE__*/_jsxs(Hidden, {
            below: "xs",
            accessible: true,
            as: "span",
            children: [hasUnsavedChanges && /*#__PURE__*/_jsx(DotIcon, {
              vAlign: true,
              color: "highlight",
              mr: ""
            }), statusText]
          }), /*#__PURE__*/_jsx(Hidden, {
            above: "xs",
            as: "span",
            children: /*#__PURE__*/_jsx(DotIcon, {
              dimmed: !hasUnsavedChanges,
              color: hasUnsavedChanges ? 'highlight' : getDimmedTextColor,
              mr: "xxs"
            })
          })]
        }), stateOptions]
      })
    }), /*#__PURE__*/_jsxs(Flex, {
      shrink: true,
      gap: "s",
      children: [previewOptions && /*#__PURE__*/_jsx(Button, {
        as: NavLink,
        to: previewLocation,
        isActive: isPreviewActive,
        icon: isPreviewActive ? 'eye-closed' : 'eye-open',
        iconOnly: !s,
        children: /*#__PURE__*/_jsx(MatchTextWidth, {
          alternativeText: t('actions_exit_preview'),
          showAlternativeText: isPreviewActive,
          children: t('actions_preview')
        })
      }), /*#__PURE__*/_jsx(TooltipButton, {
        type: "submit",
        title: tooltipTitle,
        variant: "primary",
        icon: "ok",
        iconOnly: !xxs,
        onClick: onSave,
        isLoading: isSaving,
        isDisabled: isSaveDisabled,
        children: buttonText || t('actions_save_changes')
      })]
    })]
  });
}
export default EditorSaveStatus;